import * as THREE from 'three';
import * as PANOLENS from 'panolens';

class VideoThreeSixty {
  constructor (el, videoUrl) {
    this.el = el;
    this.handleResize = this.handleResize.bind(this);
    this.toggleAudio = this.toggleAudio.bind(this);
    this.allowDeviceMotion = this.allowDeviceMotion.bind(this);
    this.soundButton = this.el.querySelector('.js-mute');
    // this.allowDeviceMotionButton = this.el.querySelector('.js-allow-devicemotion');
    
    const panolensOptions = {
      loop: false,
      muted: false,
      autoplay: false,
      crossOrigin: 'anonymous'
    };

    const viewerOptions = {
      container: this.el,
      controlButtons: ['video'], // remove full screen
    };

    this.panorama = new PANOLENS.VideoPanorama(videoUrl, panolensOptions);
    this.viewer = new PANOLENS.Viewer(viewerOptions); 
    this.control = this.viewer.getControl();

    // center video
    this.control.rotateLeft(-90 * Math.PI / 180);

    this.viewer.add(this.panorama);

    // set fov for screen size.
    this.handleResize();

    this.init();
  }

  init() {
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.panorama.addEventListener('enter-fade-start', () => {
      console.log('enter-fade-start');
    });

    this.panorama.addEventListener('enter-fade-complete', () => {
      console.log('enter-fade-complete');
    });

    // audio button click
    this.soundButton.addEventListener('touchstart', this.toggleAudio);
    this.soundButton.addEventListener('click', this.toggleAudio);

    // this.allowDeviceMotionButton.addEventListener('click', this.allowDeviceMotion);

    window.addEventListener('resize', this.handleResize);
  }

  muteVideo() {
    this.panorama.muteVideo();
  }

  unmuteVideo() {
    this.panorama.unmuteVideo();
  }

  toggleAudio(e) {
    e.preventDefault();
    if (this.soundButton.classList.contains('is-muted')) {
      this.soundButton.classList.remove('is-muted');
      this.unmuteVideo();
    } else {
      this.soundButton.classList.add('is-muted');
      this.muteVideo();
    }
  }

  allowDeviceMotion(e) {
    // e.preventDefault();
    if (typeof(DeviceMotionEvent) !== 'undefined' && typeof(DeviceMotionEvent.requestPermission) === 'function') {
      DeviceMotionEvent.requestPermission()
        .then(response => {
          if (response == 'granted') {
            console.log('granted');
          }
        })
        .catch(error => {
          console.error(error);
        });
    } else {
      console.log('DeviceMotionEvent is not defined');
    }
  }

  handleResize() {
    const winWidth = window.innerWidth;
    if (winWidth >= 768) {
      this.viewer.setCameraFov(100);
    } else {
      this.viewer.setCameraFov(120);
    }
  }
}

export default VideoThreeSixty;